import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-filter-check",
  "use": "default-filter-check-usage",
  "viewBox": "0 0 32 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 25\" id=\"default-filter-check\"><g fill-rule=\"evenodd\"><path d=\"M.636 14.464l2.828-2.828 9.9 9.9-2.828 2.828z\" /><path d=\"M29.192-.02l2.829 2.828L10.808 24.02l-2.829-2.829z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol